import React, { useRef, useEffect} from 'react'
import PrimaryTitle from '../../../../components/PrimaryTitle'
import { inject, observer } from 'mobx-react'
import { Input, DateInput } from '../../../../components/formComponents'
import { Form, Button } from 'react-bootstrap'
import DocumentStore from '../../../../store/documentForm.store'
import PropTypes from 'prop-types'
import t from '../../../../service/translate.service'
import ContractSelector from '../../../../components/contractSelector'
import { buildValidators } from '../../../../service/validate'
import { Alert } from 'antd'
import { useNavigate } from 'react-router-dom'

const Deposit = (props) => {
  const inputRefs = useRef({})
  const { model, setVal, depositOutpaymentValidators, depositOutpaymentValidatorInputs, errorsList, errorListVoice, submitted   } = DocumentStore
  const { file } = props
  const validatorBlur = buildValidators(depositOutpaymentValidatorInputs, true)
  const navigate = useNavigate()

  const generateErrorList = () => {
    const errors = []
    for (let key in inputRefs?.current) {
      const item = inputRefs?.current[key]
      if (key === 'date' || key === 'depositTerminationDate' || key === 'depositApartmentHandoverDate') {
        if (validatorBlur[key] && validatorBlur[key](item?.props?.selected, item?.props['aria-label'])) {
          let err = validatorBlur[key](item?.props?.selected, item?.props['aria-label'])
          errors.push(
            <button
              key={key}
              type='button'
              onClick={() => {
                item.setFocus()
              }}
            >
              {err?.replace(/[€\*]/g, '')}
            </button>
          )
        }
      } else {
        if (validatorBlur[key] && validatorBlur[key](item.value, item.ariaLabel)) {

          let err = validatorBlur[key](item.value, item.ariaLabel)
          errors.push(
            <button
              key={key}
              type='button'
              onClick={() => {
                item.focus()
              }}
            >
              {err?.replace(/[€\*]/g, '')}
            </button>
          )
        }
      }       
    }
    return errors
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    DocumentStore.submit(file.fileName, props.contractStore.selectedContract.contractNumber, generateErrorList)
  }
  const getAttrs = field => {
    return {
      value: model[field],
      onChange: e => setVal(field, e.target.value),
      validate: depositOutpaymentValidators[field],
      blurValidate: validatorBlur[field]
    }
  }

  const AlertContent = () => {
    if (errorsList?.length > 0) {
      if (props?.documentFormHolderRef) {
        props.documentFormHolderRef?.current?.scrollTo(0,0)
      }
      return (
        <Alert
          role={errorListVoice ? "alert" : "none"}
          message={
            <div
              className='error-list'
              role={errorListVoice ? "alert" : "none"}
              aria-live={errorListVoice ? "assertive" : "off"}
            >
              {t.REQUIRED_FIELD_MISSING}
              {errorsList?.map((err) => {
                return err
              })}
            </div>
          }
          type='error'
          style={{ marginTop: '12px', marginBottom: '12px' }}
        />
      )
    } else {
      return (<></>)
    }
  }
  return (
    <div className="form-holder">
      <PrimaryTitle title={t.DEPOSIT} />
      {submitted && (
        <AlertContent />
      )}
      <Form>
        <ContractSelector required={true} label padding page='documents' isDigitalForm={true} loadPrepayments={DocumentStore.loadPrepayments} aria-label={t.SELECT_CONTRACT} />
        <h3 className='inputs-text'>{t.DEPOSIT_HEAD_ONE}</h3>
        <Input ref={(el) => (inputRefs.current['firstName'] = el)} autoComplete='given-name' name='firstName' {...getAttrs('firstName')} label={t.DIGITAL_CONTRACT_FORM_FIRST_NAME + '*'} aria-label={t.FIRST_NAME} />
        <Input ref={(el) => (inputRefs.current['lastName'] = el)} autoComplete='family-name' name='lastName' {...getAttrs('lastName')} label={t.DIGITAL_CONTRACT_FORM_LAST_NAME + '*'} aria-label={t.LAST_NAME} />
        <Input ref={(el) => (inputRefs.current['depositCurrentAddress'] = el)} autoComplete='street-address' name='depositCurrentAddress' {...getAttrs('depositCurrentAddress')} label={t.DIGITAL_CONTRACT_FORM_CURRENT_ADDRESS + '*'} aria-label={t.CURRENT_ADDRESS} />
        <Input ref={(el) => (inputRefs.current['phone'] = el)} autoComplete='tel' name='phone' {...getAttrs('phone')} label={t.DIGITAL_CONTRACT_FORM_PHONE_NUMBER + '*'} aria-label={t.PHONE_NUMBER} />
        <h3 className='inputs-text'>{t.DEPOSIT_HEAD_TWO}</h3>
        <Input ref={(el) => (inputRefs.current['address'] = el)} name='address' {...getAttrs('address')} label={t.DIGITAL_CONTRACT_FORM_APARTMENT_ADDRESS + '*'} aria-label={t.APARTMENT_ADDRESS} />
        <Input ref={(el) => (inputRefs.current['tenantNo'] = el)} name='tenantNo' {...getAttrs('tenantNo')} label={t.DIGITAL_CONTRACT_FORM_TENANT_NUMBER + '*'} disabled aria-label={t.TENANT_NUMBER} />
        <DateInput blurValidate={validatorBlur['depositTerminationDate']} ref={(el) => (inputRefs.current['depositTerminationDate'] = el)} name='depositTerminationDate' value={model['depositTerminationDate']} onChange={(date) => setVal('depositTerminationDate', date)} validate={depositOutpaymentValidators['depositTerminationDate']} label={t.DIGITAL_CONTRACT_FORM_TERMINATION_DATE + '*'} aria-label={t.TERMINATION_DATE} />
        <DateInput blurValidate={validatorBlur['depositApartmentHandoverDate']} ref={(el) => (inputRefs.current['depositApartmentHandoverDate'] = el)} name='depositApartmentHandoverDate' value={model['depositApartmentHandoverDate']} onChange={(date) => setVal('depositApartmentHandoverDate', date)} validate={depositOutpaymentValidators['depositApartmentHandoverDate']} label={t.DIGITAL_CONTRACT_FORM_APARTMENT_HANDOVER_DATE + '*'} aria-label={t.HANDOVER_DATE} />
        <Input ref={(el) => (inputRefs.current['depositAmount'] = el)} disabled={model.depositAmount ? true : false} value={model.depositAmount} name='depositAmount' {...getAttrs('depositAmount')} label={t.DIGITAL_CONTRACT_FORM_DEPOSIT_AMOUNT + '*'} aria-label={t.DEPOSIT_AMOUNT} />
        <h3 className='inputs-text'>{t.DEPOSIT_HEAD_THREE}</h3>
        <Input ref={(el) => (inputRefs.current['depositAccountHolder'] = el)} name='depositAccountHolder' {...getAttrs('depositAccountHolder')} label={t.DIGITAL_CONTRACT_FORM_ACCOUNT_HOLDER + '*'} aria-label={t.ACCOUNT_HOLDER} />
        <Input ref={(el) => (inputRefs.current['depositIban'] = el)} name='depositIban' {...getAttrs('depositIban')} label={t.DIGITAL_CONTRACT_FORM_IBAN + '*'} aria-label={t.IBAN} />
        <Input ref={(el) => (inputRefs.current['depositBic'] = el)} name='depositBic' {...getAttrs('depositBic')} label={t.DIGITAL_CONTRACT_FORM_BIC + '*'} aria-label={t.BIC} />
        <p className='input-para'>{t.DEPOSIT_PARA_ONE}</p>
        <Input ref={(el) => (inputRefs.current['place'] = el)} autoComplete="address-level2" name='place' {...getAttrs('place')} label={t.DIGITAL_CONTRACT_FORM_PLACE + '*'} aria-label={t.PLACE} />
        <DateInput blurValidate={validatorBlur['date']} ref={(el) => (inputRefs.current['date'] = el)} name='date' value={model['date']} onChange={(date) => setVal('date', date)} validate={depositOutpaymentValidators['date']} label={t.DIGITAL_CONTRACT_FORM_DATE + '*'} aria-label={t.DATE} />
        <Form.Group className='actions text-center'>
          <div className='group'>
            <button
              className='button primary'
              onClick={(e) => {
                if (e.key !== 'Tab') {
                  e.preventDefault()
                }
                onSubmit(e)
              }}
              aria-label={t.SUBMIT_BUTTON}
            >
              {t.DIGITAL_CONTRACT_FORM_SEND}
            </button>
            <a
              href='/documents'
              className='button secondary'
              onClick={(e) => {
                if (e.key !== 'Tab') {
                  e.preventDefault()
                }
                DocumentStore.onCloseForm()
                navigate('/documents')
              }}
              style={{
                textDecoration: 'none',
                color: 'unset'
              }}
              aria-label={t.CANCEL_BUTTON}
            >
              {t.DIGITAL_CONTRACT_FORM_CANCEL}
            </a>
          </div>
        </Form.Group>
      </Form>
    </div>
  );
}

Deposit.propTypes = {
  file: PropTypes.object.isRequired,
  contractStore: PropTypes.object
}

export default inject('contractStore')(observer(Deposit))
